// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let OptionExt = require("../../common/OptionExt.bs.js");
let QueryParams = require("../../../reason/QueryParams.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function decode(value) {
  return Stdlib_Option.flatMap(Stdlib_Option.map(value, prim => prim.trim()), OptionExt.ofString);
}

function encode(value) {
  return value;
}

let SearchParam = {
  decode: decode,
  encode: encode
};

let config = Object.fromEntries([[
    "clientSearchTerm",
    QueryParams.UseQueryParams.ParamConfigs.fromParamConfig({
      encode: encode,
      decode: decode
    })
  ]]);

let ParamsConfig = {
  SearchParam: SearchParam,
  config: config
};

let UseQueryParams = QueryParams.UseQueryParams.Make({
  config: config
});

let encode$1 = UseQueryParams.encode;

function toQueryString(params) {
  return QueryParams.QueryString.stringify(encode$1(params));
}

let use = UseQueryParams.use;

exports.ParamsConfig = ParamsConfig;
exports.UseQueryParams = UseQueryParams;
exports.use = use;
exports.encode = encode$1;
exports.toQueryString = toQueryString;
/* config Not a pure module */
